module.exports = __webpack_public_path__ + "img/ercode01.7d8063d3.png";